var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-edit',{attrs:{"autoValidate":""},on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('Details',{attrs:{"invoiceData":_vm.invoiceData,"invoiceValidation":_vm.invoiceValidation,"userData":_vm.userData}}),_c('Invoice',{attrs:{"invoiceData":_vm.invoiceData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }